import Home from "../pages/home/Home";
import { routeName } from "./routeName";
import ListOfApplicants from "../pages/cms/list-of-applicants/ListOfApplicants";
import EntranceExamination from "../pages/cms/entrance-examination/EntranceExamination";
import PersonnelManagement from "../pages/cms/personnel-management/PersonnelManagement";
import ManageStudents from "../pages/cms/manage-students/ManageStudents";
import PersonnelManagementDetail from "../pages/cms/personnel-management/PersonnelManagementDetail";
import ManageJobTitles from "../pages/cms/manage-job-titles/ManageJobTitles";
import OrganizationChartManagement from "../pages/cms/organization-chart-management/OrganizationChartManagement";
import ManageStudentDetailPage from "../pages/cms/manage-students/ManageStudentDetail";
import EducationInfoPage from "../pages/cms/manage-students/EducationInfo";
import OnlineLeaveSubmission from "../pages/cms/online-leave-submission/OnlineLeaveSubmission";
import OnlineLeaveSubmissionDetail from "../pages/cms/online-leave-submission/OnlineLeaveSubmissionDetail";
import OnlineLeaveSubmissionCreate from "../pages/cms/online-leave-submission/OnlineLeaveSubmissionCreate";
import ManageOnlineLeaveSubmissionRequest from "../pages/cms/manage-online-leave-submission/OnlineLeaveSubmissionRequest";
import OnlineLeaveSubmissionApprove from "../pages/cms/manage-online-leave-submission/OnlineLeaveSubmissionApprove";
import SettingLeaveDay from "../pages/cms/setting-leave-day/SettingLeaveDay";
import SettingLeaveDayDetail from "../pages/cms/setting-leave-day/SettingLeaveDayDetail";
import ManageLeaveType from "../pages/cms/manage-leave-type/ManageLeaveType";
import ManageLeaveTypeCreate from "../pages/cms/manage-leave-type/ManageLeaveTypeCreate";
import ManageLeaveTypeUpdate from "../pages/cms/manage-leave-type/ManageLeaveTypeUpdate";
import LoginLogOutHistory from "../pages/cms/login-history/LoginHistory";
import TimeRecordSystem from "../pages/cms/time-record-system/TimeRecordSystem";
import TimeRecordSystemAll from "../pages/cms/time-record-system/TimeRecordSystemAll";
import ManageTimeRecordSystem from "../pages/cms/time-record-system/ManageTimeRecordSystem";
import ManageTimeRecordSystemDetail from "../pages/cms/time-record-system/ManageTimeRecordSystemDetail";
import FormPersonnelExport from "../pages/cms/personnel-management/form/FormPersonnel.export";
import PrintOnlineLeaveSubmission from "../pages/cms/print/online-leave-submission";
import ManageClassRoom from "../pages/cms/manage-class-room/ManageClassRoom";
import CreateClassRoom from "../pages/cms/manage-class-room/CreateClassRoom";
import UpdateClassRoom from "../pages/cms/manage-class-room/UpdateClassRoom";
import ManageAdvisor from "../pages/cms/manage-advisor/ManageAdvisor";
import ManageAdvisorDetail from "../pages/cms/manage-advisor/ManageAdvisorDetail";
import AdvisorConsultationDetail from "../pages/cms/manage-advisor/AdvisorConsultationDetail";
import ManageConsultationTypes from "../pages/cms/manage-consultation-types/ManageConsultationTypes";
import ManageDocuments from "../pages/cms/manage-documents/ManageDocuments";
import ChooseAdvisor from "../pages/student/choose-advisor/ChooseAdvisor";
import CreateConsultation from "../pages/student/choose-advisor/CreateConsultation";
import UpdateConsultation from "../pages/student/choose-advisor/UpdateConsultation";
import ManageEvaluationForm from "../pages/cms/manage-evaluation-form/ManageEvaluationForm";
import CreateEvaluationForm from "../pages/cms/manage-evaluation-form/CreateEvaluationForm";
import ManageAdvisorRequest from "../pages/cms/advisor/manage-advisor-request/ManageAdvisorRequest";
import AdvisorRequestDetail from "../pages/cms/advisor/manage-advisor-request/AdvisorRequestDetail";
import TransferAdvisor from "../pages/student/choose-advisor/TransferAdvisor";
import UpdateEvaluationForm from "../pages/cms/manage-evaluation-form/UpdateEvaluationForm";
import ManageStudentConsultation from "../pages/cms/advisor/manage-advisor-request/ManageStudentConsultation";
import VotingEvaluation from "../pages/student/choose-advisor/VotingEvaluation";
import ReportConsultationRequest from "../pages/cms/reports/ReportConsultationRequest";
import ReportConsultationRequestDetail from "../pages/cms/reports/ReportConsultationRequestDetail";
import ManageAdvisorRequestDetail from "../pages/cms/manage-advisor/ManageAdvisorRequestDetail";
import TransferAdvisorRequestHistory from "../pages/student/choose-advisor/TransferAdvisorRequestHistory";
import TransferAdvisorRequestHistoryDetail from "../pages/student/choose-advisor/TransferAdvisorRequestHistoryDetail";
import ExportReportConsultationRequestDetail from "../pages/cms/reports/ExportReportConsultationRequestDetail.export";
import CourseManagement from "../pages/cms/course-management/CourseManagement";
import HistoryUsingClassShedule from "../pages/cms/history-using-class-shedule/HistoryUsingClassShedule";
import TeacherEvaluationScores from "../pages/cms/advisor/teacher-evaluation-scores/TeacherEvaluationScores";
import SubjectTaught from "../pages/cms/advisor/subject-taught/SubjectTaught";
import SubjectTaughtDetail from "../pages/cms/advisor/subject-taught/SubjectTaughtDetail";
import SubjectTaughtCourseDetail from "../pages/cms/advisor/subject-taught/SubjectTaughtCourseAnnualDetail";
import TeacherEvaluationScoresEmployeeDetail from "../pages/cms/advisor/teacher-evaluation-scores/TeacherEvaluationScoresEmployeeDetail";
import TeacherEvaluationScoresEstimate from "../pages/cms/advisor/teacher-evaluation-scores/TeacherEvaluationScoresEstimate";
import TeacherEvaluationScoresEstimateDetail from "../pages/cms/advisor/teacher-evaluation-scores/TeacherEvaluationScoresEstimateDetail";
import TeacherEvaluationScoresDetail from "../pages/cms/advisor/teacher-evaluation-scores/TeacherEvaluationScoresDetail";
import EvaluationScoresFromStudents from "../pages/cms/advisor/evaluation-scores-from-students/EvaluationScoresFromStudents";
import EvaluationScoresFromStudentsDetail from "../pages/cms/advisor/evaluation-scores-from-students/EvaluationScoresFromStudentsDetail";
import EvaluationScoresFromStudentsEstimateDetail from "../pages/cms/advisor/evaluation-scores-from-students/EvaluationScoresFromStudentsEstimateDetail";
import ManageMeetingCategories from "../pages/cms/EMeeting/manage-categories/manage-categories";
import ManageMeetingPositions from "../pages/cms/EMeeting/manage-positions/manage-positions";
import MeetingCalendar from "../pages/cms/EMeeting/meeting-calendar/meeting-calendar";
import MeetingCaledarDetail from "../pages/cms/EMeeting/meeting-calendar/meeting-caledar-detail";
import AddMeetingParticipants from "../pages/cms/EMeeting/meeting-calendar/add-meeting-participants";
import CourseOfStudy from "../pages/cms/course-of-study/course-of-study";
import CourseOfStudyDetail from "../pages/cms/course-of-study/course-of-study-detail";
import CourseOfStudyAddSubject from "../pages/cms/course-of-study/course-of-study-add-subject";
import StudentsCourseOfStudy from "../pages/students/course-of-study/course-of-study";
import StudentsCourseOfStudyDetail from "../pages/students/course-of-study/course-of-study-detail";
import StudentsCourseDetail from "../pages/students/course-of-study/course-detail";
import EvaluateTeachers from "../pages/students/course-of-study/evaluate-teachers";
import AddAgenda from "../pages/cms/EMeeting/meeting-calendar/add-agenda";
import StudentsMeetingCalendar from "../pages/students/meeting-calendar/meeting-calendar";
import StudentsMeetingCalendarDetail from "../pages/students/meeting-calendar/meeting-caledar-detail";
import ComplaintSubmitList from "../pages/students/complaint/ComplaintSubmitList";
import ComplaintSubmitDetail from "../pages/students/complaint/ComplaintSubmitDetail";
import ComplaintList from "../pages/cms/complaint/ComplaintList";
import ComplaintDetail from "../pages/cms/complaint/ComplaintDetail";
import ComplaintType from "../pages/cms/complaint/ComplaintType";
import ComplaintStatistics from "../pages/cms/complaint/ComplaintStatistics";
// import ComplaintSubmitList from "../pages/cms/complaint/ComplaintSubmitList";
import EThesisCategories from "../pages/cms/EThesis/e-thesis-categories";
import EThesisType from "../pages/cms/EThesis/e-thesis-type";
import RulesRegulations from "../pages/cms/EThesis/rules-regulations";
import EThesisLibrary from "../pages/cms/EThesis/e-thesis-library";
import ScheduleCalenda from "../pages/cms/EThesis/schedule-calenda";
import EThesisProgress from "../pages/cms/EThesis/e-thesis-progress";
import EThesisHistory from "../pages/cms/EThesis/history";
import AddEThesisLibrary from "../pages/cms/EThesis/add-e-thesis-library";
import AddScheduleCalenda from "../pages/cms/EThesis/add-schedule-calenda";
import ListExaminationDate from "../pages/cms/EThesis/list-examination-date";
import StudentsScheduleCalenda from "../pages/students/schedule-calenda/schedule-calenda";
import StudentsAddExaminationCalendar from "../pages/students/schedule-calenda/add-examination-calendar";
import StudentsEThesisLibrary from "../pages/students/EThesis/e-thesis-library";
import DetailEThesisLibrary from "../pages/students/EThesis/detail-e-thesis-library";
import DetailExamination from "../pages/cms/EThesis/detail-examination";
import ListThesisProgress from "../pages/cms/EThesis/list-thesis-progress";
import StudentsThesisProgress from "../pages/students/thesis-progress/list-thesis-progress";
import StudentsAddThesisProgress from "../pages/students/thesis-progress/add-thesis-progress";
import AddThesisProgress from "../pages/cms/EThesis/add-thesis-progress";
import StudentsRulesRegulations from "../pages/students/rules-regulations/rules-regulations";
import BookingRoomRequestManagementContainer from "../pages/cms/booking-room-request-mangement";
import BookingRoomManagementContainer from "../pages/cms/booking-room-management";
import BookingDeviceManagementContainer from "../pages/cms/booking-device-mangement";
import BookingFeesManagementContainer from "../pages/cms/booking-service-fees-mangement";
import BookingServiceFeesManagement from "../pages/cms/booking-room-usage-report";
import BookingDeviceManagementFormContainer from "../pages/cms/booking-device-mangement/device_management_form";
import BookingRoomManagementDetail from "../pages/cms/booking-room-management/BookingRoomManagementDetail";
import BookingRoomDetail from "../pages/cms/booking-room/BookingRoomDetail";
import CourseOnlineStatistics from "../pages/cms/course-online/statistics/CourseOnlineStatistics";
import ManageTags from "../pages/cms/course-online/manage-tags/ManageTags";
import ManageCourseType from "../pages/cms/course-online/manage-course-type/ManageCourseType";
import ManagePaymentChannel from "../pages/cms/course-online/manage-payment-channel/ManagePaymentChannel";
import ManageCourseOnlinePayment from "../pages/cms/course-online/manage-payment/ManageCourseOnlinePayment";
import ManageCourseOnlinePaymentDetail from "../pages/cms/course-online/manage-payment/ManageCourseOnlinePaymentDetail";
import ManageSurveys from "../pages/cms/course-online/manage-surveys/ManageSurveys";
import ManageSurveysDetail from "../pages/cms/course-online/manage-surveys/ManageSurveysDetail";
import ManageCourseTest from "../pages/cms/course-online/manage-course-test/ManageCourseTest";
import ManageCourseTestDetail from "../pages/cms/course-online/manage-course-test/ManageCourseTestDetail";
import ListOnlineCourses from "../pages/students/online-course/list-online-courses";
import OnlineCourses from "../pages/students/online-course/online-courses";
import DetailOnlineCourse from "../pages/students/online-course/detail-online-course";
import PaymentOnlineCourse from "../pages/students/online-course/payment-online-course";
import ShoppingCart from "../pages/students/shopping-cart/shopping-cart";
import TakeLesson from "../pages/students/online-course/take-lesson";
import OnlineCourseManagement from "../pages/cms/course-online/online-course-management/online-course-management";
import OnlineCourseCreate from "../pages/cms/course-online/online-course-management/online-course-create";
import OnlineCourseDiploma from "../pages/cms/course-online/diploma/online-course-diploma";
import OnlineCourseDiplomaCreate from "../pages/cms/course-online/diploma/online-course-diploma-create";
import MyOnlineCourse from "../pages/students/my-online-course/my-online-course";
import EdpexAddProject from "../pages/cms/edpex/add-project";
import EdpexAddResponsiblePerson from "../pages/cms/edpex/add-responsible-person";
import EdpexCriteria from "../pages/cms/edpex/edpex-criteria";
import EdpexMission from "../pages/cms/edpex/mission";
import EdpexResponsibleProject from "../pages/cms/edpex/responsible-projects";
import EdpexResultDisplay from "../pages/cms/edpex/result-display";
import EdpexSampleProjectData from "../pages/cms/edpex/sample-project-data";
import EdpexSpecialEditRequest from "../pages/cms/edpex/special-edit-request";
import EdpexSampleSummaryData from "../pages/cms/edpex/sample-summary-data";
import FormAddProject from "../pages/cms/edpex/add-project/FormAddProject";
import FormResponsibleProject from "../pages/cms/edpex/responsible-projects/FormResponsibleProject";
import FormSpecialEditRequest from "../pages/cms/edpex/special-edit-request/FormSpecialEditRequest";
import EdPexDisplayPage from "../pages/cms/edpex/display-page/EdPexDisplayPage";
import FormCompleteResponsibleProject from "../pages/cms/edpex/responsible-projects/FormCompleteResponsibleProject";
import Login from "../pages/auth/login";
import Dashboard from "../pages/cms-website/dashboard/Dashboard";
import WelcomePage from "../pages/cms-website/welcome";
import HeaderStructure from "../pages/cms-website/website-structure/header/HeaderStructure";
import FooterStructure from "../pages/cms-website/website-structure/footer/FooterStructure";
import MenuStructure from "../pages/cms-website/website-structure/menu/MenuStructure";
import BannerSlide from "../pages/cms-website/website-structure/banner-slide/BannerSlide";
import ContactStructure from "../pages/cms-website/website-structure/contact/ContactStructure";
import ContentStructure from "../pages/cms-website/website-structure/content/ContentStructure";
import ContentStructureDetail from "../pages/cms-website/website-structure/content/ContentStructureDetail";
import ManageFile from "../pages/cms-website/setting/manage-file/ManageFile";
import CollectionsImage from "../pages/cms-website/collections/collections-image/CollectionsImage";
import CollectionsVdo from "../pages/cms-website/collections/collections-vdo/CollectionsVdo";
import CollectionsImageDetail from "../pages/cms-website/collections/collections-image/CollectionsImageDetail";
import CollectionsVdoDetail from "../pages/cms-website/collections/collections-vdo/CollectionsVdoDetail";
import CalendarActivity from "../pages/cms-website/calendar-activity/CalendarActivity";
import CalendarActivityDetail from "../pages/cms-website/calendar-activity/CalendarActivityDetail";
import PollVote from "../pages/cms-website/poll-vote/PollVote";
import PollVoteDetail from "../pages/cms-website/poll-vote/PollVoteDetail";
import ContentNews from "../pages/cms-website/content-news/ContentNews";
import ContentNewsDetail from "../pages/cms-website/content-news/ContentNewsDetail";
import ContentAdmission from "../pages/cms-website/content-admission/ContentAdmission";
import BannerSlideList from "../pages/cms-website/website-structure/banner-slide/BannerSlideList";
import BannerSlideDetail from "../pages/cms-website/website-structure/banner-slide/BannerSlideDetail";
import LevelFacultyManagement from "../pages/admission/level-faculty-management/LevelFacultyManagement";
import GalleryType from "../pages/cms-website/setting/gallery-type/gallery-type";
import ActivityCategories from "../pages/cms-website/setting/activity-categories/activity-categories";
import NewsCategories from "../pages/cms-website/setting/news-categories/news-categories";
import TagManage from "../pages/cms/setting/tag-manage/tag-manage";
import PollCategories from "../pages/cms-website/setting/poll-categories/poll-categories";
import PermissionList from "../pages/cms-website/setting/permission/PermissionList";
import PermissionDetail from "../pages/cms-website/setting/permission/PermissionDetail";
import EmployeeList from "../pages/cms-website/setting/employee/EmployeeList";
import EmployeeAdd from "../pages/cms-website/setting/employee/EmployeeAdd";
import CollaborationNetwork from "../pages/cms/collaboration-network/collaboration-network";
import Comment from "../pages/cms/comment/comment";
import LoginLog from "../pages/cms-website/setting/login-log/login-log";
import ListApplicants from "../pages/admission/list-applicants/list-applicants";
import ApplicentDetail from "../pages/admission/list-applicants/applicent-detail";
import ManageExams from "../pages/admission/manage-exams/manage-exams";
import PeriodExamination from "../pages/admission/period-examination/period-examination";
import InterviewStudent from "../pages/admission/interview-student/interview-student";
import PeriodExaminationDetail from "../pages/admission/period-examination/period-examination-detail";
import ManageExamsDetail from "../pages/admission/manage-exams/manage-exams-detail";
import InterviewStudentDetail from "../pages/admission/interview-student/interview-student-detail";
import StudentRegistration from "../pages/admission/student-registration/student-registration";
import StudentRegistrationDetail from "../pages/admission/student-registration/student-registration-detail";
import StudentRegistrationInformation from "../pages/admission/student-registration-information/student-registration-information";
import StudentRegistrationInformationDetail from "../pages/admission/student-registration-information/student-registration-information-detail";
import ManageAcademicYear from "../pages/admission/manage-academic-year/manage-academic-year";
import SetupCourseOpening from "../pages/admission/setup-course-opening/setup-course-opening";
import ManagePDPA from "../pages/admission/manage-PDPA/manage-PDPA";
import SetupCourseOpeningDetail from "../pages/admission/setup-course-opening/setup-course-opening-detail";
import SetTuitionFees from "../pages/admission/set-tuition-fees/set-tuition-fees";
import SetTuitionFeesDetail from "../pages/admission/set-tuition-fees/set-tuition-fees-detail";
import ManagePayment from "../pages/admission/manage-payment/manage-payment";
import ManagePaymentDetail from "../pages/admission/manage-payment/manage-payment-detail";
import CourseTuitionFees from "../pages/admission/set-tuition-fees/course-tuition-fees";

import Organizational from "../pages/home/organization/page";
import OrganizationalDetail from "../pages/home/organization/[id_employee]/page";
import PollVoteWebsite from "../pages/home/poll-vote/page";
import GalleryList from "../pages/home/gallery/page";
import GalleryDetail from "../pages/home/gallery/[id_gallery]/page";
import PressRelease from "../pages/home/press-release/PressRelease";
import PressReleaseDetail from "../pages/home/press-release/PressReleaseDetail";
import AdmissionWebsite from "../pages/home/admission/AdmissionWebsite";
import Activity from "../pages/home/activity/Activity";
import ActivityDetail from "../pages/home/activity/ActivityDetail";
import LoginMember from "../pages/auth/LoginMember";
import ContentDetail from "../pages/home/content/ContentDetail";
import ProfileEmployee from "../pages/cms-website/profile/ProfileEmployee";
import IBSCOnlineAdmission from "../pages/admission/IBSC-online-admission/IBSC-online-admission";
import AdmissionForm from "../pages/admission/IBSC-online-admission/admission-Form";
import CheckPDPA from "../pages/admission/IBSC-online-admission/check-PDPA";
import HistoryOnlineAdmission from "../pages/admission/history-online-Admission/history-online-Admission";
import AdmissionDetail from "../pages/admission/history-online-Admission/admission-detail";
import FormExamination from "../pages/admission/history-online-Admission/form-examination";
import StudentDetail from "../pages/admission/period-examination/student-detail";
import TermPayment from "../pages/admission/term-payment/term-payment";
import TermPaymentDetail from "../pages/admission/term-payment/term-payment-detail";
import ManageBooks from "../pages/elibrary/elibrary-setting/manage-books/ManageBooks";
import ManageBooksDetail from "../pages/elibrary/elibrary-setting/manage-books/ManageBooksDetail";
import ManageLibraryType from "../pages/elibrary/elibrary-setting/manage-library-type/ManageLibraryType";
import ManageLibraryAuthor from "../pages/elibrary/elibrary-setting/manage-library-author/ManageLibraryAuthor";
import ManageLibraryBanner from "../pages/elibrary/elibrary-setting/manage-banner/ManageBanner";
import ManagePaymentChannels from "../pages/elibrary/elibrary-setting/manage-payment-channels/ManagePaymentChannels";
import ManageReport from "../pages/elibrary/elibrary-setting/manage-report/ManageReport";
import ManageOrders from "../pages/elibrary/elibrary-setting/manage-orders/ManageOrders";
import ManageEbooks from "../pages/elibrary/elibrary-setting/manage-ebooks/ManageEbooks";
import ManageEbooksDetail from "../pages/elibrary/elibrary-setting/manage-ebooks/ManageEbooksDetail";
import ManageTheSes from "../pages/elibrary/elibrary-setting/manage-theses/ManageTheSes";
import ManageTheSesDetail from "../pages/elibrary/elibrary-setting/manage-theses/ManageTheSesDetail";
import ManageJournal from "../pages/elibrary/elibrary-setting/manage-journal/ManageJournal";
import ManageJournalDetail from "../pages/elibrary/elibrary-setting/manage-journal/ManageJournalDetail";
import ManagePodcast from "../pages/elibrary/elibrary-setting/manage-podcast/ManagePodcast";
import ManagePodcastDetail from "../pages/elibrary/elibrary-setting/manage-podcast/ManagePodcastDetail";
import ManageVideos from "../pages/elibrary/elibrary-setting/manage-videos/ManageVideos";
import ManageVideosDetail from "../pages/elibrary/elibrary-setting/manage-videos/ManageVideosDetail";
import Books from "../pages/elibrary/elibrary-system/books/Books";
import BooksList from "../pages/elibrary/elibrary-system/books/BooksList";
import BooksDetail from "../pages/elibrary/elibrary-system/books/BooksDetail";
import BorrowBooks from "../pages/elibrary/elibrary-system/books/BorrowBooks";
import ShoppingCartBooks from "../pages/elibrary/elibrary-system/element/ShoppingCartBooks";
import EBooks from "../pages/elibrary/elibrary-system/e-books/EBooks";
import EbooksList from "../pages/elibrary/elibrary-system/e-books/EbooksList";
import StudentEducation from "../pages/admission/student-registration-information/student-education";
import TermFeesDetail from "../pages/admission/student-registration-information/termFeesDetail";
import ManageOrdersDetail from "../pages/elibrary/elibrary-setting/manage-orders/ManageOrdersDetail";
import ManageBorrowDetail from "../pages/elibrary/elibrary-setting/manage-borrow/ManageBorrowDetail";
import ManageBorrow from "../pages/elibrary/elibrary-setting/manage-borrow/ManageBorrow";
import EbooksDetail from "../pages/elibrary/elibrary-system/e-books/EbooksDetail";
import Journal from "../pages/elibrary/elibrary-system/journal/Journal";
import JournalList from "../pages/elibrary/elibrary-system/journal/JournalList";
import JournalDetail from "../pages/elibrary/elibrary-system/journal/JournalDetail";
import TheSis from "../pages/elibrary/elibrary-system/the-sis/TheSis";
import TheSisList from "../pages/elibrary/elibrary-system/the-sis/TheSisList";
import TheSisDetail from "../pages/elibrary/elibrary-system/the-sis/TheSisDetail";
import Podcast from "../pages/elibrary/elibrary-system/podcast/Podcast";
import PodcastList from "../pages/elibrary/elibrary-system/podcast/PodcastList";
import PodcastDetail from "../pages/elibrary/elibrary-system/podcast/PodcastDetail";
import Videos from "../pages/elibrary/elibrary-system/videos/Videos";
import VideosList from "../pages/elibrary/elibrary-system/videos/VideosList";
import VideoDetail from "../pages/elibrary/elibrary-system/videos/VideoDetail";
import AudioBooks from "../pages/elibrary/elibrary-system/audio-book/AudioBooks";
import AudioBooksList from "../pages/elibrary/elibrary-system/audio-book/AudioBooksList";
import AudioBookDetail from "../pages/elibrary/elibrary-system/audio-book/AudioBookDetail";
import ManageAudioBook from "../pages/elibrary/elibrary-setting/manage-audio-book/ManageAudioBook";
import ManageAudioBookDetail from "../pages/elibrary/elibrary-setting/manage-audio-book/ManageAudioBookDetail";
import ELibrarySearchGlobal from "../pages/elibrary/elibrary-system/search-e-library-global/ElibrarySearchGlobal";
import ManageRequestForms from "../pages/request-form/manage-request-forms/manage-request-forms";
import ManageRequestFormDetail from "../pages/request-form/manage-request-forms/manage-request-form-detail";
import VisaRequest from "../pages/request-form/visa-request/visa-request";
import VisaRequestCreate from "../pages/request-form/visa-request/visa-request-create";
import VisaRequestDetail from "../pages/request-form/visa-request/visa-request-detail";
import ManageRequest from "../pages/request-form/manage-request/manage-request";
import ManageRequestDetail from "../pages/request-form/manage-request/manage-request-detail";
import ManagePaymentChannelsVisa from "../pages/request-form/manage-payment-channels/ManagePaymentChannels";
import VisaIntendant from "../pages/request-form/visa-intendant/visa-intendant";
import NotificationList from "../pages/cms/notification/NotificationList";
import ManageSampleFiles from "../pages/cms/EMeeting/manage-sample-files/manage-sample-files";
import LeaveFormPublic from "../pages/cms/online-leave-submission/public/LeaveFormPublic";
import ClassroomMeetingBooking from "../pages/home/classroom-meeting-booking/ClassroomMeetingBooking";
import ClassroomMeetingBookingDetail from "../pages/home/classroom-meeting-booking/ClassroomMeetingBookingDetail";
import ExampleCourse from "../pages/students/online-course/example-course";
import EvaluateTeachersDetail from "../pages/students/course-of-study/evaluate-teachers-detail";
import DetailAgenda from "../pages/students/meeting-calendar/detail-agenda";
interface routerData {
  key: string;
  pathName: string;
  elements: JSX.Element | React.ReactNode;
}

export const publicRouteData: routerData[] = [
  {
    key: "HOME",
    pathName: routeName.main.home,
    elements: <Home />,
  },
  {
    key: "LOGIN_MEMBER",
    pathName: routeName.authentication.login_member,
    elements: <LoginMember />,
  },
  {
    key: "ORGANIZATION",
    pathName: routeName.main.organization,
    elements: <Organizational />,
  },
  {
    key: "ORGANIZATION_DETAIL",
    pathName: routeName.main.organizationDetail,
    elements: <OrganizationalDetail />,
  },
  {
    key: "POLL_VOTE",
    pathName: routeName.main.pollVote,
    elements: <PollVoteWebsite />,
  },
  {
    key: "GALLERY_LIST",
    pathName: routeName.main.galleryList,
    elements: <GalleryList />,
  },
  {
    key: "GALLERY_DETAIL",
    pathName: routeName.main.galleryDetail,
    elements: <GalleryDetail />,
  },
  {
    key: "pressRelease",
    pathName: routeName.main.pressRelease,
    elements: <PressRelease />,
  },
  {
    key: "pressReleaseDetail",
    pathName: routeName.main.pressReleaseDetail,
    elements: <PressReleaseDetail />,
  },
  {
    key: "admission",
    pathName: routeName.main.admission,
    elements: <AdmissionWebsite />,
  },
  {
    key: "activity",
    pathName: routeName.main.activity,
    elements: <Activity />,
  },
  {
    key: "activityDetail",
    pathName: routeName.main.activityDetail,
    elements: <ActivityDetail />,
  },
  {
    key: "contentDetail",
    pathName: routeName.main.contentDetail,
    elements: <ContentDetail />,
  },
];

export const member_route_public: routerData[] = [
  {
    key: "ClassroomMeetingBooking",
    pathName: routeName.public.classroom_meeting_booking,
    elements: <ClassroomMeetingBooking />,
  },
  {
    key: "ClassroomMeetingBookingCreate",
    pathName: routeName.public.classroom_meeting_booking_create,
    elements: <ClassroomMeetingBookingDetail />,
  },
  {
    key: "ClassroomMeetingBookingView",
    pathName: routeName.public.classroom_meeting_booking_view,
    elements: <ClassroomMeetingBookingDetail view={true} />,
  },
  {
    key: "ClassroomMeetingBookingDetail",
    pathName: routeName.public.classroom_meeting_booking_detail,
    elements: <ClassroomMeetingBookingDetail />,
  },
]

export const memberRouteData: routerData[] = [
  {
    key: "IBSCOnlineAdmission",
    pathName: routeName.admission.IBSCOnlineAdmission,
    elements: <IBSCOnlineAdmission />,
  },
  {
    key: "CheckPDPA",
    pathName: routeName.admission.CheckPDPA,
    elements: <CheckPDPA />,
  },
  {
    key: "AdmissionForm",
    pathName: routeName.admission.AdmissionForm,
    elements: <AdmissionForm />,
  },
  {
    key: "AdmissionFormUpdte",
    pathName: routeName.admission.AdmissionFormUpdte,
    elements: <AdmissionForm />,
  },
  {
    key: "HistoryOnlineAdmission",
    pathName: routeName.admission.HistoryOnlineAdmission,
    elements: <HistoryOnlineAdmission />,
  },
  {
    key: "AdmissionDetail",
    pathName: routeName.admission.AdmissionDetail,
    elements: <AdmissionDetail />,
  },
  {
    key: "FormExamination",
    pathName: routeName.admission.FormExamination,
    elements: <FormExamination />,
  },
]

export const privateRouteData: routerData[] = [
  {
    key: "NotificationList",
    pathName: routeName.cms.Notifications,
    elements: <NotificationList />,
  },
  {
    key: "ListOfApplicants",
    pathName: routeName.cms.ListOfApplicants,
    elements: <ListOfApplicants />,
  },
  {
    key: "EntranceExamination",
    pathName: routeName.cms.EntranceExamination,
    elements: <EntranceExamination />,
  },
  {
    key: "PersonnelManagement",
    pathName: routeName.cms.PersonnelManagement,
    elements: <PersonnelManagement />,
  },
  {
    key: "PersonnelManagementDetail",
    pathName: routeName.cms.PersonnelManagementDetail,
    elements: <PersonnelManagementDetail ONLY_VIEW={false} />,
  },
  {
    key: "PersonnelManagementDetailById",
    pathName: routeName.cms.PersonnelManagementDetailById,
    elements: <PersonnelManagementDetail ONLY_VIEW={false} />,
  },
  {
    key: "PersonnelManagementDetailByIdOnlyView",
    pathName: routeName.cms.PersonnelManagementDetailViewById,
    elements: <PersonnelManagementDetail ONLY_VIEW />,
  },
  {
    key: "ManageStudents",
    pathName: routeName.cms.ManageStudents,
    elements: <ManageStudents />,
  },
  {
    key: "ManageStudentDetail",
    pathName: routeName.cms.ManageStudentDetail,
    elements: <ManageStudentDetailPage />,
  },
  {
    key: "ManageStudentEducationInfo",
    pathName: routeName.cms.ManageStudentEducationInfo,
    elements: <EducationInfoPage />,
  },
  {
    key: "ManageJobTitles",
    pathName: routeName.cms.ManageJobTitles,
    elements: <ManageJobTitles />,
  },
  {
    key: "OrganizationChartManagement",
    pathName: routeName.cms.OrganizationChartManagement,
    elements: <OrganizationChartManagement />,
  },
  {
    key: "OnlineLeaveSubmission",
    pathName: routeName.cms.OnlineLeaveSubmission,
    elements: <OnlineLeaveSubmission />,
  },
  {
    key: "OnlineLeaveSubmissionCreate",
    pathName: routeName.cms.OnlineLeaveSubmissionCreate,
    elements: <OnlineLeaveSubmissionCreate />,
  },
  {
    key: "OnlineLeaveSubmissionDetail",
    pathName: routeName.cms.OnlineLeaveSubmissionDetail,
    elements: <OnlineLeaveSubmissionDetail />,
  },
  {
    key: "OnlineLeaveSubmissionRequest",
    pathName: routeName.cms.OnlineLeaveSubmissionRequest,
    elements: <ManageOnlineLeaveSubmissionRequest />,
  },
  {
    key: "OnlineLeaveSubmissionApprove",
    pathName: routeName.cms.OnlineLeaveSubmissionApprove,
    elements: <OnlineLeaveSubmissionApprove />,
  },
  {
    key: "SettingLeaveDay",
    pathName: routeName.cms.SettingLeaveDay,
    elements: <SettingLeaveDay />,
  },
  {
    key: "SettingLeaveDayDetail",
    pathName: routeName.cms.SettingLeaveDayDetail,
    elements: <SettingLeaveDayDetail />,
  },
  {
    key: "ManageLeaveType",
    pathName: routeName.cms.ManageLeaveType,
    elements: <ManageLeaveType />,
  },
  {
    key: "ManageLeaveTypeCreate",
    pathName: routeName.cms.ManageLeaveTypeCreate,
    elements: <ManageLeaveTypeCreate />,
  },
  {
    key: "ManageLeaveTypeUpdate",
    pathName: routeName.cms.ManageLeaveTypeUpdate,
    elements: <ManageLeaveTypeUpdate />,
  },

  {
    key: "TimeRecordSystem",
    pathName: routeName.cms.TimeRecordSystem,
    elements: <TimeRecordSystem />,
  },
  {
    key: "TimeRecordSystemAll",
    pathName: routeName.cms.TimeRecordSystemAll,
    elements: <TimeRecordSystemAll />,
  },
  {
    key: "ManageTimeRecordSystem",
    pathName: routeName.cms.ManageTimeRecordSystem,
    elements: <ManageTimeRecordSystem />,
  },
  {
    key: "ManageTimeRecordSystemDetail",
    pathName: routeName.cms.ManageTimeRecordSystemDetail,
    elements: <ManageTimeRecordSystemDetail />,
  },
  {
    key: "LoginHistory",
    pathName: routeName.cms.LoginHistory,
    elements: <LoginLogOutHistory />,
  },
  {
    key: "courseManagement",
    pathName: routeName.cms.courseManagement,
    elements: <CourseManagement />,
  },

  // module 2
  {
    key: "ManageClassRoom",
    pathName: routeName.cms.ManageClassRoom,
    elements: <ManageClassRoom />,
  },
  {
    key: "CreateClassRoom",
    pathName: routeName.cms.CreateClassRoom,
    elements: <CreateClassRoom />,
  },
  {
    key: "UpdateClassRoom",
    pathName: routeName.cms.UpdateClassRoom,
    elements: <UpdateClassRoom />,
  },

  {
    key: "ManageEvaluationForm",
    pathName: routeName.cms.ManageEvaluationForm,
    elements: <ManageEvaluationForm />,
  },

  {
    key: "CreateEvaluationForm",
    pathName: routeName.cms.CreateEvaluationForm,
    elements: <CreateEvaluationForm />,
  },

  {
    key: "ManageEvaluationFormUpdate",
    pathName: routeName.cms.ManageEvaluationFormUpdate,
    elements: <UpdateEvaluationForm />,
  },

  {
    key: "AdvisorSystem",
    pathName: routeName.cms.AdvisorSystem,
    elements: "AdvisorSystem",
  },

  {
    key: "ManageAdvisors",
    pathName: routeName.cms.manageAdvisors,
    elements: <ManageAdvisor />,
  },
  {
    key: "ManageAdvisorDetail",
    pathName: routeName.cms.ManageAdvisorDetail,
    elements: <ManageAdvisorDetail />,
  },
  {
    key: "AdvisorConsultationDetail",
    pathName: routeName.cms.AdvisorConsultationDetail,
    elements: <AdvisorConsultationDetail />,
  },

  {
    key: "ManageConsultationTypes",
    pathName: routeName.cms.manageConsultationTypes,
    elements: <ManageConsultationTypes />,
  },
  {
    key: "ManageDocuments",
    pathName: routeName.cms.manageDocuments,
    elements: <ManageDocuments />,
  },
  {
    key: "ConsultingReport",
    pathName: routeName.cms.consultingReport,
    elements: <ReportConsultationRequest />,
  },

  {
    key: "ConsultingReportDetail",
    pathName: routeName.cms.consultingReportDetail,
    elements: <ReportConsultationRequestDetail />,
  },

  {
    key: "HistoryUsingClassShedule",
    pathName: routeName.cms.history_using_class_shedule,
    elements: <HistoryUsingClassShedule />,
  },
  // student
  {
    key: "StudentSchedule",
    pathName: routeName.student.schedule,
    elements: "StudentSchedule",
  },
  {
    key: "StudentChooseAdvisor",
    pathName: routeName.student.chooseAdvisor,
    elements: <ChooseAdvisor />,
  },
  {
    key: "TransferAdvisor",
    pathName: routeName.student.TransferAdvisorRequest,
    elements: <TransferAdvisor />,
  },
  {
    key: "CreateConsultation",
    pathName: routeName.student.createConsultation,
    elements: <CreateConsultation />,
  },
  {
    key: "UpdateConsultation",
    pathName: routeName.student.updateConsultation,
    elements: <UpdateConsultation />,
  },
  {
    key: "votingEvaluation",
    pathName: routeName.student.votingEvaluation,
    elements: <VotingEvaluation />,
  },
  {
    key: "TransferAdvisorRequestHistory",
    pathName: routeName.student.TransferAdvisorRequestHistory,
    elements: <TransferAdvisorRequestHistory />,
  },
  {
    key: "TransferAdvisorRequestHistoryDetail",
    pathName: routeName.student.TransferAdvisorRequestHistoryDetail,
    elements: <TransferAdvisorRequestHistoryDetail />,
  },

  // advisor
  //
  {
    key: "SubjectTaught",
    pathName: routeName.advisor.SubjectTaught,
    elements: <SubjectTaught />,
  },
  {
    key: "SubjectTaughtDetail",
    pathName: routeName.advisor.SubjectTaughtDetail,
    elements: <SubjectTaughtDetail />,
  },
  {
    key: "SubjectTaughtDetail",
    pathName: routeName.advisor.SubjectTaughtCourseAnnualDetail,
    elements: <SubjectTaughtCourseDetail />,
  },
  //
  {
    key: "TeacherEvaluationScores",
    pathName: routeName.advisor.TeacherEvaluationScores,
    elements: <TeacherEvaluationScores />,
  },
  {
    key: "TeacherEvaluationScoresDetail",
    pathName: routeName.advisor.TeacherEvaluationScoresDetail,
    elements: <TeacherEvaluationScoresDetail />,
  },
  {
    key: "TeacherEvaluationScoresEmployeeDetail",
    pathName: routeName.advisor.TeacherEvaluationScoresEmployeeDetail,
    elements: <TeacherEvaluationScoresEmployeeDetail />,
  },
  {
    key: "TeacherEvaluationScoreCourseEstimate",
    pathName: routeName.advisor.TeacherEvaluationScoreCourseEstimate,
    elements: <TeacherEvaluationScoresEstimate />,
  },
  {
    key: "TeacherEvaluationScoreCourseEstimateDetail",
    pathName: routeName.advisor.TeacherEvaluationScoreCourseEstimateDetail,
    elements: <TeacherEvaluationScoresEstimateDetail />,
  },
  //
  {
    key: "EvaluationScoresFromStudents",
    pathName: routeName.advisor.EvaluationScoresFromStudents,
    elements: <EvaluationScoresFromStudents />,
  },
  {
    key: "EvaluationScoresFromStudentsDetail",
    pathName: routeName.advisor.EvaluationScoresFromStudentsCourselist,
    elements: <EvaluationScoresFromStudentsDetail />,
  },
  {
    key: "EvaluationScoresFromStudentsEstimate",
    pathName:
      routeName.advisor.EvaluationScoresFromStudentsDetailCourseEstimateDetail,
    elements: <EvaluationScoresFromStudentsEstimateDetail />,
  },
  //
  {
    key: "ManageAdvisorRequest",
    pathName: routeName.advisor.manageAdvisorRequest,
    elements: <ManageAdvisorRequest />,
  },
  {
    key: "AdvisorRequestDetail",
    pathName: routeName.advisor.advisorRequestDetail,
    elements: <AdvisorRequestDetail />,
  },
  {
    key: "  ManageAdvisorRequestDetail",
    pathName: routeName.cms.manageAdvisorRequestDetail,
    elements: <ManageAdvisorRequestDetail />,
  },
  {
    key: "manageStudentConsultation",
    pathName: routeName.advisor.manageStudentConsultation,
    elements: <ManageStudentConsultation />,
  },
  {
    key: "ManageMeetingCategories",
    pathName: routeName.cms.ManageMeetingCategories,
    elements: <ManageMeetingCategories />,
  },
  {
    key: "ManageMeetingPositions",
    pathName: routeName.cms.ManageMeetingPositions,
    elements: <ManageMeetingPositions />,
  },
  {
    key: "ManageSampleFiles",
    pathName: routeName.cms.ManageSampleFiles,
    elements: <ManageSampleFiles />,
  },
  {
    key: "MeetingCalendar",
    pathName: routeName.cms.MeetingCalendar,
    elements: <MeetingCalendar />,
  },
  {
    key: "MeetingCaledarCreate",
    pathName: routeName.cms.MeetingCaledarCreate,
    elements: <MeetingCaledarDetail />,
  },
  {
    key: "MeetingCaledarDetail",
    pathName: routeName.cms.MeetingCaledarDetail,
    elements: <MeetingCaledarDetail />,
  },
  {
    key: "AddMeetingParticipants",
    pathName: routeName.cms.AddMeetingParticipants,
    elements: <AddMeetingParticipants />,
  },
  {
    key: "DetailMeetingParticipants",
    pathName: routeName.cms.DetailMeetingParticipants,
    elements: <AddMeetingParticipants />,
  },
  {
    key: "AddMeetingParticipants",
    pathName: routeName.cms.AddAgenda,
    elements: <AddAgenda />,
  },
  {
    key: "AddMeetingParticipants",
    pathName: routeName.cms.AddSubAgenda,
    elements: <AddAgenda />,
  },
  {
    key: "AddMeetingParticipants",
    pathName: routeName.cms.DetailSubAgenda,
    elements: <DetailAgenda />,
  },
  {
    key: "CourseofStudy",
    pathName: routeName.cms.CourseofStudy,
    elements: <CourseOfStudy />,
  },
  {
    key: "CourseOfStudyDetail",
    pathName: routeName.cms.CourseOfStudyDetail,
    elements: <CourseOfStudyDetail />,
  },
  {
    key: "CourseOfStudyAddSubject",
    pathName: routeName.cms.CourseOfStudyAddSubject,
    elements: <CourseOfStudyAddSubject />,
  },
  {
    key: "CourseOfStudySubjectDetail",
    pathName: routeName.cms.CourseOfStudySubjectDetail,
    elements: <CourseOfStudyAddSubject />,
  },
  {
    key: "CourseofStudy",
    pathName: routeName.students.CourseofStudy,
    elements: <StudentsCourseOfStudy />,
  },
  {
    key: "CourseofStudy",
    pathName: routeName.students.CourseOfStudyDetail,
    elements: <StudentsCourseOfStudyDetail />,
  },
  {
    key: "CourseofStudy",
    pathName: routeName.students.CourseDetail,
    elements: <StudentsCourseDetail />,
  },
  {
    key: "CourseofStudy",
    pathName: routeName.students.EvaluateTeachers,
    elements: <EvaluateTeachers />,
  },
  {
    key: "CourseofStudy",
    pathName: routeName.students.EvaluateTeachersDetail,
    elements: <EvaluateTeachersDetail />,
  },
  {
    key: "MeetingCalendar",
    pathName: routeName.students.MeetingCalendar,
    elements: <StudentsMeetingCalendar />,
  },
  {
    key: "MeetingCalendar",
    pathName: routeName.students.MeetingCaledarDetail,
    elements: <StudentsMeetingCalendarDetail />,
  },

  // ร้องเรียน(ผู้ยื่น)
  {
    key: "complaintSubmit",
    pathName: routeName.students.complaintSubmit,
    elements: <ComplaintSubmitList />,
  },
  {
    key: "complaintSubmitCreate",
    pathName: routeName.students.complaintSubmitCreate,
    elements: <ComplaintSubmitDetail view={false} />,
  },
  {
    key: "complaintSubmitDetail",
    pathName: routeName.students.complaintSubmitDetail,
    elements: <ComplaintSubmitDetail view={false} />,
  },
  {
    key: "complaintSubmitDetailView",
    pathName: routeName.students.complaintSubmitDetailView,
    elements: <ComplaintSubmitDetail view={true} />,
  },

  // ร้องเรียน(ผู้รับเรื่อง)
  {
    key: "complaintSystem",
    pathName: routeName.cms.complaintSystem,
    elements: <ComplaintList />,
  },
  {
    key: "complaintSystemDetail",
    pathName: routeName.cms.complaintSystemDetail,
    elements: <ComplaintDetail view={false} />,
  },
  {
    key: "complaintSystemDetailView",
    pathName: routeName.cms.complaintSystemDetailView,
    elements: <ComplaintDetail view={true} />,
  },
  {
    key: "complaintTypes",
    pathName: routeName.cms.complaintsType,
    elements: <ComplaintType />,
  },
  {
    key: "complaintStatistics",
    pathName: routeName.cms.complaintsStatistics,
    elements: <ComplaintStatistics />,
  },

  {
    key: "EThesisCategories",
    pathName: routeName.cms.EThesisCategories,
    elements: <EThesisCategories />,
  },
  {
    key: "EThesisType",
    pathName: routeName.cms.EThesisType,
    elements: <EThesisType />,
  },
  {
    key: "RulesRegulations",
    pathName: routeName.cms.RulesRegulations,
    elements: <RulesRegulations />,
  },
  {
    key: "EThesisLibrary",
    pathName: routeName.cms.EThesisLibrary,
    elements: <EThesisLibrary />,
  },
  {
    key: "AddEThesisLibrary",
    pathName: routeName.cms.AddEThesisLibrary,
    elements: <AddEThesisLibrary />,
  },
  {
    key: "DetailEThesisLibrary",
    pathName: routeName.cms.DetailEThesisLibrary,
    elements: <AddEThesisLibrary />,
  },
  {
    key: "ScheduleCalenda",
    pathName: routeName.cms.ScheduleCalenda,
    elements: <ScheduleCalenda />,
  },
  {
    key: "AddScheduleCalenda",
    pathName: routeName.cms.AddScheduleCalenda,
    elements: <AddScheduleCalenda />,
  },
  {
    key: "ListExaminationDate",
    pathName: routeName.cms.ListExaminationDate,
    elements: <ListExaminationDate />,
  },
  {
    key: "DetailExamination",
    pathName: routeName.cms.DetaiExamination,
    elements: <DetailExamination />,
  },
  {
    key: "DetailScheduleCalenda",
    pathName: routeName.cms.DetailScheduleCalenda,
    elements: <AddScheduleCalenda />,
  },
  {
    key: "EThesisProgress",
    pathName: routeName.cms.EThesisProgress,
    elements: <EThesisProgress />,
  },
  {
    key: "ListThesisProgress",
    pathName: routeName.cms.ListThesisProgress,
    elements: <ListThesisProgress />,
  },
  {
    key: "DetailThesisProgress",
    pathName: routeName.cms.DetailThesisProgress,
    elements: <AddThesisProgress />,
  },
  {
    key: "ListThesisProgress",
    pathName: routeName.students.EThesisProgress,
    elements: <StudentsThesisProgress />,
  },
  {
    key: "StudentsAddThesisProgress",
    pathName: routeName.students.StudentsAddThesisProgress,
    elements: <StudentsAddThesisProgress />,
  },
  {
    key: "StudentsDateilThesisProgress",
    pathName: routeName.students.StudentsDateilThesisProgress,
    elements: <StudentsAddThesisProgress />,
  },
  {
    key: "StudentsViewThesisProgress",
    pathName: routeName.students.StudentsDateilThesisProgress,
    elements: <StudentsAddThesisProgress />,
  },
  {
    key: "EThesisHistory",
    pathName: routeName.cms.EThesisHistory,
    elements: <EThesisHistory />,
  },
  {
    key: "StudentsScheduleCalenda",
    pathName: routeName.students.ScheduleCalenda,
    elements: <StudentsScheduleCalenda />,
  },
  {
    key: "StudentsAddExaminationCalendar",
    pathName: routeName.students.StudentsAddExaminationCalendar,
    elements: <StudentsAddExaminationCalendar />,
  },
  {
    key: "StudentsEThesisLibrary",
    pathName: routeName.students.EThesisLibrary,
    elements: <StudentsEThesisLibrary />,
  },
  {
    key: "DetailEThesisLibrary",
    pathName: routeName.students.DetailEThesisLibrary,
    elements: <DetailEThesisLibrary />,
  },
  {
    key: "StudentsRulesRegulations",
    pathName: routeName.students.RulesRegulations,
    elements: <StudentsRulesRegulations />,
  },
  // Start Booking class room and meeting room
  {
    key: "BookingRoom",
    pathName: routeName.cms.BookingRoom,
    elements: <ClassroomMeetingBooking
      is_personal
    />,
  },
  {
    key: "BookingRoomCreate",
    pathName: routeName.cms.BookingRoomCreate,
    elements: <ClassroomMeetingBookingDetail is_personal={true} view={false} />,
  },
  {
    key: "BookingRoomUpdate",
    pathName: routeName.cms.BookingRoomUpdate,
    elements: <ClassroomMeetingBookingDetail is_personal={true} view={false} />,
  },
  {
    key: "BookingRoomView",
    pathName: routeName.cms.BookingRoomView,
    elements: <ClassroomMeetingBookingDetail is_personal={true} view={true} />,
  },

  {
    key: "BookingRoomRequest",
    pathName: routeName.cms.BookingRoomRequestUpdate,
    elements: <BookingRoomDetail
      path_list={routeName.cms.BookingRoomRequestMangement}
      title="จัดการคำร้องขอจอง"
      sub_title="รายละเอียดคำร้องขอจอง"
      view={false}
      is_request
    />,
  },
  {
    key: "BookingRoomRequestView",
    pathName: routeName.cms.BookingRoomRequestView,
    elements: <BookingRoomDetail
      path_list={routeName.cms.BookingRoomRequestMangement}
      title="จัดการคำร้องขอจอง"
      sub_title="รายละเอียดคำร้องขอจอง"
      view={true}
      is_request
    />,
  },
  {
    key: "BookingRoomRequestMangement",
    pathName: routeName.cms.BookingRoomRequestMangement,
    elements: <BookingRoomRequestManagementContainer />,
  },
  {
    key: "BookingRoomManagement",
    pathName: routeName.cms.BookingRoomManagement,
    elements: <BookingRoomManagementContainer />,
  },
  {
    key: "BookingRoomManagementCreate",
    pathName: routeName.cms.BookingRoomManagementCreate,
    elements: <BookingRoomManagementDetail view={false} />,
  },
  {
    key: "BookingRoomManagementUpdate",
    pathName: routeName.cms.BookingRoomManagementUpdate,
    elements: <BookingRoomManagementDetail view={true} />,
  },
  //
  {
    key: "BookingRoomDeviceManagement",
    pathName: routeName.cms.BookingRoomDeviceManagement,
    elements: <BookingDeviceManagementContainer />,
  },
  {
    key: "BookingRoomDeviceManagementForm",
    pathName: routeName.cms.BookingRoomDeviceManagementForm,
    elements: <BookingDeviceManagementFormContainer />,
  },
  //
  {
    key: "BookingRoomServiceFeesMangement",
    pathName: routeName.cms.BookingRoomServiceFeesMangement,
    elements: <BookingFeesManagementContainer />,
  },
  //
  {
    key: "BookingRoomPaymentChannelManagement",
    pathName: routeName.cms.BookingRoomPaymentChannelManagement,
    elements: <ManagePaymentChannels
      type_channel_payment="PAYMENT_MEETING_ROOM"
      title="ปฏิทินจองห้องเรียนและห้องประชุม"
      path_sub_title={routeName.cms.BookingRoomPaymentChannelManagement}
    />,
  },
  //
  {
    key: "BookingRoomUsageReports",
    pathName: routeName.cms.BookingRoomUsageReports,
    elements: <BookingServiceFeesManagement />,
  },
  // End Booking class room and meeting room


  // ระบบ EDPEX
  // {
  //   key: "edpex-display-page",
  //   pathName: routeName.cms.edPexDisplayPage,
  //   elements: <EdPexDisplayPage />,
  // },


  // จัดการข้อมูลคอร์สออนไลน์
  {
    key: "course_online_statistics",
    pathName: routeName.cms.course_online_statistics,
    elements: <CourseOnlineStatistics />,
  },
  {
    key: "course_online_tags",
    pathName: routeName.cms.course_online_tags,
    elements: <ManageTags />,
  },
  {
    key: "course_online_course_type",
    pathName: routeName.cms.course_online_course_type,
    elements: <ManageCourseType />,
  },
  {
    key: "course_online_payment_channels",
    pathName: routeName.cms.course_online_payment_channels,
    elements: <ManagePaymentChannel />,
  },
  {
    key: "course_online_payment",
    pathName: routeName.cms.course_online_payment,
    elements: <ManageCourseOnlinePayment />,
  },
  {
    key: "course_online_payment_detail",
    pathName: routeName.cms.course_online_payment_detail,
    elements: <ManageCourseOnlinePaymentDetail view={false} />,
  },
  {
    key: "course_online_payment_view",
    pathName: routeName.cms.course_online_payment_view,
    elements: <ManageCourseOnlinePaymentDetail view={true} />,
  },
  {
    key: "course_online_surveys",
    pathName: routeName.cms.course_online_surveys,
    elements: <ManageSurveys />,
  },
  {
    key: "course_online_surveys_create",
    pathName: routeName.cms.course_online_surveys_create,
    elements: <ManageSurveysDetail view={false} />,
  },
  {
    key: "course_online_surveys_view",
    pathName: routeName.cms.course_online_surveys_view,
    elements: <ManageSurveysDetail view={true} />,
  },
  {
    key: "course_online_surveys_detail",
    pathName: routeName.cms.course_online_surveys_detail,
    elements: <ManageSurveysDetail view={false} />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.students.OnlineCourse,
    elements: <OnlineCourses />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.students.ListOnlineCourse,
    elements: <ListOnlineCourses />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.students.OnlineCourseDetail,
    elements: <DetailOnlineCourse />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.students.ExampleCourse,
    elements: <ExampleCourse />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.students.PaymentOnlineCourse,
    elements: <PaymentOnlineCourse />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.students.PaymentOnlineAllCourse,
    elements: <PaymentOnlineCourse />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.students.ShoppingCart,
    elements: <ShoppingCart />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.students.TakeLesson,
    elements: <TakeLesson />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.cms.OnlineCourseManagement,
    elements: <OnlineCourseManagement />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.cms.OnlineCourseManagementCreate,
    elements: <OnlineCourseCreate />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.cms.OnlineCourseManagementDetail,
    elements: <OnlineCourseCreate />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.cms.OnlineCourseManagementView,
    elements: <OnlineCourseCreate view={true}/>,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.cms.OnlineCourseDiploma,
    elements: <OnlineCourseDiploma />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.cms.OnlineCourseDiplomaCreate,
    elements: <OnlineCourseDiplomaCreate />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.cms.OnlineCourseDiplomaDetail,
    elements: <OnlineCourseDiplomaCreate />,
  },
  {
    key: "OnlineCourse",
    pathName: routeName.students.MyOnlineCourse,
    elements: <MyOnlineCourse />,
  },

  {
    key: "course_online_test",
    pathName: routeName.cms.course_online_quiz,
    elements: <ManageCourseTest />,
  },
  {
    key: "course_online_test_create",
    pathName: routeName.cms.course_online_quiz_create,
    elements: <ManageCourseTestDetail view={false} />,
  },
  {
    key: "course_online_test_detail",
    pathName: routeName.cms.course_online_quiz_detail,
    elements: <ManageCourseTestDetail view={false} />,
  },
  {
    key: "course_online_test_view",
    pathName: routeName.cms.course_online_quiz_view,
    elements: <ManageCourseTestDetail view={true} />,
  },
  // edpex
  {
    key: "result_display",
    pathName: "/edpex-dashboard/result-display",
    elements: <EdPexDisplayPage />
  },
  {
    key: "responsible_projects",
    pathName: "/edpex-dashboard/responsible-projects",
    elements: <EdpexResponsibleProject />,
  },
  {
    key: "responsible_projects_update",
    pathName: "/edpex-dashboard/responsible-projects/:id/detail",
    elements: <FormResponsibleProject />,
  },

  {
    key: "responsible_projects_complete",
    pathName: "/edpex-dashboard/responsible-projects/:id/complete",
    elements: <FormCompleteResponsibleProject />,
  },

  {
    key: "add_responsible_person",
    pathName: "/edpex-dashboard/add-responsible-person",
    elements: <EdpexAddResponsiblePerson />,
  },
  {
    key: "add_project",
    pathName: "/edpex-dashboard/add-project",
    elements: <EdpexAddProject />,
  },
  {
    key: "add_project_create",
    pathName: "/edpex-dashboard/add-project/create",
    elements: <FormAddProject />,
  },
  {
    key: "add_project_update",
    pathName: "/edpex-dashboard/add-project/:id/detail",
    elements: <FormAddProject />,
  },
  {
    key: "special_edit_request",
    pathName: "/edpex-dashboard/special-edit-request",
    elements: <EdpexSpecialEditRequest />,
  },
  {
    key: "special_edit_request_detail",
    pathName: "/edpex-dashboard/special-edit-request/:id/detail",
    elements: <FormSpecialEditRequest />,
  },
  {
    key: "edpex_criteria",
    pathName: "/edpex-dashboard/edpex-criteria",
    elements: <EdpexCriteria />,
  },
  {
    key: "mission",
    pathName: "/edpex-dashboard/mission",
    elements: <EdpexMission />,
  },
  {
    key: "sample_project_data",
    pathName: "/edpex-dashboard/sample-project-data",
    elements: <EdpexSampleProjectData />,
  },
  {
    key: "sample_summary_dataa",
    pathName: "/edpex-dashboard/sample-summary-data",
    elements: <EdpexSampleSummaryData />,
  },



  // CMS WEBSITE
  {
    key: "MANAGE_WEBSITE_DASHBAORD",
    pathName: routeName.cms_website.dashboard,
    elements: <Dashboard />,
  },
  {
    key: "MANAGE_WEBSITE_INTRO",
    pathName: routeName.cms_website.intro,
    elements: <WelcomePage />,
  },
  {
    key: "website_structure_header",
    pathName: routeName.cms_website.website_structure_header,
    elements: <HeaderStructure />,
  },
  {
    key: "website_structure_footer",
    pathName: routeName.cms_website.website_structure_footer,
    elements: <FooterStructure />,
  },
  {
    key: "website_structure_menu_header",
    pathName: routeName.cms_website.website_structure_menu_header,
    elements: <MenuStructure />,
  },
  {
    key: "website_structure_banner_slide",
    pathName: routeName.cms_website.website_structure_banner_slide_list,
    elements: <BannerSlideList />,
  },
  {
    key: "website_structure_banner_slide",
    pathName: routeName.cms_website.website_structure_banner_slide,
    elements: <BannerSlide />,
  },
  {
    key: "website_structure_banner_slide_create",
    pathName: routeName.cms_website.website_structure_banner_slide_create,
    elements: <BannerSlideDetail view={false} />,
  },
  {
    key: "website_structure_banner_slide_view",
    pathName: routeName.cms_website.website_structure_banner_slide_view,
    elements: <BannerSlideDetail view={true} />,
  },
  {
    key: "website_structure_banner_slide_detail",
    pathName: routeName.cms_website.website_structure_banner_slide_detail,
    elements: <BannerSlideDetail view={false} />,
  },
  {
    key: "website_structure_contact",
    pathName: routeName.cms_website.website_structure_contact,
    elements: <ContactStructure />,
  },
  {
    key: "website_structure_content",
    pathName: routeName.cms_website.website_structure_content,
    elements: <ContentStructure />,
  },
  {
    key: "website_structure_content_create",
    pathName: routeName.cms_website.website_structure_content_create,
    elements: <ContentStructureDetail view={false} />,
  },
  {
    key: "website_structure_content_view",
    pathName: routeName.cms_website.website_structure_content_view,
    elements: <ContentStructureDetail view={true} />,
  },
  {
    key: "website_structure_content_detail",
    pathName: routeName.cms_website.website_structure_content_detail,
    elements: <ContentStructureDetail view={false} />,
  },
  {
    key: "collections_image",
    pathName: routeName.cms_website.collection_image,
    elements: <CollectionsImage />,
  },
  {
    key: "collections_image_detail",
    pathName: routeName.cms_website.collection_image_detail,
    elements: <CollectionsImageDetail view={false} />,
  },
  {
    key: "collections_image_detail_view",
    pathName: routeName.cms_website.collection_image_view,
    elements: <CollectionsImageDetail view={true} />,
  },
  {
    key: "collections_image_create",
    pathName: routeName.cms_website.collection_image_create,
    elements: <CollectionsImageDetail view={false} />,
  },
  {
    key: "collection_vdo",
    pathName: routeName.cms_website.collection_vdo,
    elements: <CollectionsVdo />,
  },
  {
    key: "collection_vdo_detail",
    pathName: routeName.cms_website.collection_vdo_detail,
    elements: <CollectionsVdoDetail view={false} />,
  },
  {
    key: "collection_vdo_view",
    pathName: routeName.cms_website.collection_vdo_view,
    elements: <CollectionsVdoDetail view={true} />,
  },
  {
    key: "collection_vdo_create",
    pathName: routeName.cms_website.collection_vdo_create,
    elements: <CollectionsVdoDetail view={false} />,
  },
  {
    key: "calendar_activity",
    pathName: routeName.cms_website.calendar_activity,
    elements: <CalendarActivity />,
  },
  {
    key: "calendar_activity_create",
    pathName: routeName.cms_website.calendar_activity_create,
    elements: <CalendarActivityDetail view={false} />,
  },
  {
    key: "calendar_activity_detail",
    pathName: routeName.cms_website.calendar_activity_detail,
    elements: <CalendarActivityDetail view={false} />,
  },
  {
    key: "calendar_activity_view",
    pathName: routeName.cms_website.calendar_activity_view,
    elements: <CalendarActivityDetail view={true} />,
  },
  {
    key: "poll_vote",
    pathName: routeName.cms_website.poll_vote,
    elements: <PollVote />,
  },
  {
    key: "poll_vote_create",
    pathName: routeName.cms_website.poll_vote_create,
    elements: <PollVoteDetail view={false} />,
  },
  {
    key: "poll_vote_detail",
    pathName: routeName.cms_website.poll_vote_detail,
    elements: <PollVoteDetail view={false} />,
  },
  {
    key: "poll_vote_view",
    pathName: routeName.cms_website.poll_vote_view,
    elements: <PollVoteDetail view={true} />,
  },
  {
    key: "content_news",
    pathName: routeName.cms_website.content_news,
    elements: <ContentNews />,
  },
  {
    key: "content_news_detail",
    pathName: routeName.cms_website.content_news_detail,
    elements: <ContentNewsDetail />,
  },
  {
    key: "content_news_view",
    pathName: routeName.cms_website.content_news_view,
    elements: <ContentNewsDetail view={true} />,
  },
  {
    key: "content_news_create",
    pathName: routeName.cms_website.content_news_create,
    elements: <ContentNewsDetail />,
  },
  {
    key: "admission_form",
    pathName: routeName.cms_website.admission_form,
    elements: <ContentAdmission />,
  },
  {
    key: "setting_manage_tag",
    pathName: routeName.cms_website.setting_manage_tag,
    elements: <ManageTags is_setting />,
  },
  {
    key: "setting_manage_file",
    pathName: routeName.cms_website.setting_manage_file,
    elements: <ManageFile />,
  },

  {
    key: "GalleryTypeManagement",
    pathName: routeName.cms_website.GalleryTypeManagement,
    elements: <GalleryType />,
  },
  {
    key: "ActivityCategoriesManagement",
    pathName: routeName.cms_website.ActivityCategoriesManagement,
    elements: <ActivityCategories />,
  },
  {
    key: "NewsCategoriesManagement",
    pathName: routeName.cms_website.NewsCategoriesManagement,
    elements: <NewsCategories />,
  },
  {
    key: "TagManagement",
    pathName: routeName.cms_website.TagManagement,
    elements: <TagManage />,
  },
  {
    key: "PollCategories",
    pathName: routeName.cms_website.PollCategoriesManagement,
    elements: <PollCategories />,
  },
  {
    key: "PermissionList",
    pathName: routeName.cms_website.permission,
    elements: <PermissionList code={""} />,
  },
  {
    key: "PermissionDetail",
    pathName: routeName.cms_website.permissionCreate,
    elements: <PermissionDetail view={false} />,
  },
  {
    key: "PermissionDetail",
    pathName: routeName.cms_website.permissionDetail,
    elements: <PermissionDetail view={false} />,
  },
  {
    key: "PermissionDetail",
    pathName: routeName.cms_website.permissionDetailView,
    elements: <PermissionDetail view={true} />,
  },
  {
    key: "CollaborationNetwork",
    pathName: routeName.cms_website.collaborationNetwork,
    elements: <CollaborationNetwork />,
  },
  {
    key: "comment",
    pathName: routeName.cms_website.comment,
    elements: <Comment />,
  },
  {
    key: "EmployeeList",
    pathName: routeName.cms_website.employee,
    elements: <EmployeeList code={""} />,
  },
  {
    key: "EmployeeList",
    pathName: routeName.cms_website.employeeAdd,
    elements: <EmployeeAdd />,
  },
  {
    key: "employeeDetail",
    pathName: routeName.cms_website.employeeDetail,
    elements: <EmployeeAdd />,
  },
  {
    key: "employeeView",
    pathName: routeName.cms_website.employeeView,
    elements: <EmployeeAdd view />,
  },
  {
    key: "EmployeeList",
    pathName: routeName.cms_website.loginLog,
    elements: <LoginLog />,
  },



  {
    key: "ListApplicants",
    pathName: routeName.admission.list_applicants,
    elements: <ListApplicants />,
  },
  {
    key: "ApplicentDetail",
    pathName: routeName.admission.applicants_detail,
    elements: <ApplicentDetail />,
  },
  {
    key: "ManageExams",
    pathName: routeName.admission.manage_exams,
    elements: <ManageExams />,
  },
  {
    key: "ManageExamsDetail",
    pathName: routeName.admission.manage_exams_add,
    elements: <ManageExamsDetail />,
  },
  {
    key: "ManageExamsDetail",
    pathName: routeName.admission.manage_exams_detail,
    elements: <ManageExamsDetail />,
  },
  {
    key: "ManageExamsDetail",
    pathName: routeName.admission.manage_exams_view,
    elements: <ManageExamsDetail view={true} />,
  },
  {
    key: "PeriodExamination",
    pathName: routeName.admission.period_examination,
    elements: <PeriodExamination />,
  },
  {
    key: "PeriodExaminationDetail",
    pathName: routeName.admission.period_examination_add,
    elements: <PeriodExaminationDetail />,
  },
  {
    key: "PeriodExaminationDetail",
    pathName: routeName.admission.period_examination_view,
    elements: <PeriodExaminationDetail />,
  },
  {
    key: "PeriodExaminationDetail",
    pathName: routeName.admission.period_examination_detail,
    elements: <PeriodExaminationDetail />,
  },
  {
    key: "AdmissionExamDetail",
    pathName: routeName.admission.admission_exam_detail,
    elements: <StudentDetail />,
  },
  {
    key: "AdmissionExamDetail",
    pathName: routeName.admission.admission_exam_view,
    elements: <StudentDetail view={true} />,
  },
  {
    key: "InterviewStudent",
    pathName: routeName.admission.interview_student,
    elements: <InterviewStudent />,
  },
  {
    key: "InterviewStudentDetail",
    pathName: routeName.admission.interview_student_view,
    elements: <InterviewStudentDetail />,
  },
  {
    key: "InterviewStudentDetail",
    pathName: routeName.admission.interview_student_detail,
    elements: <InterviewStudentDetail />,
  },
  {
    key: "InterviewStudentDetail",
    pathName: routeName.admission.student_registration,
    elements: <StudentRegistration />,
  },
  {
    key: "InterviewStudentDetail",
    pathName: routeName.admission.student_registration_view,
    elements: <StudentRegistrationDetail />,
  },
  {
    key: "TermPayment",
    pathName: routeName.admission.term_payment,
    elements: <TermPayment />,
  },
  {
    key: "TermPayment",
    pathName: routeName.admission.term_payment_detail,
    elements: <TermPaymentDetail />,
  },
  {
    key: "TermPayment",
    pathName: routeName.admission.term_payment_view,
    elements: <TermPaymentDetail />,
  },

  {
    key: "StudentRegistrationInformation",
    pathName: routeName.admission.student_registration_information,
    elements: <StudentRegistrationInformation />,
  },
  {
    key: "InterviewStudentDetail",
    pathName: routeName.admission.student_registration_information_view,
    elements: <StudentRegistrationInformationDetail view={true} />,
  },
  {
    key: "InterviewStudentDetail",
    pathName: routeName.admission.student_registration_information_detail,
    elements: <StudentRegistrationInformationDetail />,
  },
  {
    key: "InterviewStudentDetail",
    pathName: routeName.admission.student_registration_information_education_view,
    elements: <StudentEducation view={true} />,
  },
  {
    key: "InterviewStudentDetail",
    pathName: routeName.admission.student_registration_information_education,
    elements: <StudentEducation />,
  },
  {
    key: "InterviewStudentDetail",
    pathName: routeName.admission.student_registration_information_term_fees,
    elements: <TermFeesDetail />,
  },

  {
    key: "LevelFacultyManagement",
    pathName: routeName.admission.LevelFacultyManagement,
    elements: <LevelFacultyManagement />,
  },
  {
    key: "ManageAcademicYear",
    pathName: routeName.admission.ManageAcademicYear,
    elements: <ManageAcademicYear />,
  },
  {
    key: "SetupCourseOpening",
    pathName: routeName.admission.SetupCourseOpening,
    elements: <SetupCourseOpening />,
  },
  {
    key: "SetupCourseOpening",
    pathName: routeName.admission.SetupCourseOpeningView,
    elements: <SetupCourseOpeningDetail view={true} />,
  },
  {
    key: "SetupCourseOpening",
    pathName: routeName.admission.SetupCourseOpeningDetail,
    elements: <SetupCourseOpeningDetail />,
  },
  {
    key: "SetTuitionFees",
    pathName: routeName.admission.SetTuitionFees,
    elements: <SetTuitionFees />,
  },
  {
    key: "SetTuitionFees",
    pathName: routeName.admission.SetTuitionFeesView,
    elements: <SetTuitionFeesDetail />,
  },
  // {
  //   key: "SetTuitionFees",
  //   pathName: routeName.admission.SetTuitionFeesDetail,
  //   elements: <SetTuitionFeesDetail />,
  // },
  {
    key: "CourseTuitionFees",
    pathName: routeName.admission.CourseTuitionFees,
    elements: <CourseTuitionFees />,
  },
  {
    key: "ManagePayment",
    pathName: routeName.admission.ManagePayment,
    elements: <ManagePayment />,
  },
  {
    key: "ManagePaymentDetail",
    pathName: routeName.admission.ManagePaymentAdd,
    elements: <ManagePaymentDetail />,
  },
  {
    key: "ManagePaymentDetail",
    pathName: routeName.admission.ManagePaymentView,
    elements: <ManagePaymentDetail view={true} />,
  },
  {
    key: "ManagePaymentDetail",
    pathName: routeName.admission.ManagePaymentDetail,
    elements: <ManagePaymentDetail />,
  },
  {
    key: "ManagePDPA",
    pathName: routeName.admission.ManagePDPA,
    elements: <ManagePDPA />,
  },
  {
    key: "PROFILE_EMPLOYEE",
    pathName: routeName.cms_website.profile_employee,
    elements: <ProfileEmployee />,
  },

  // E LIBRARY 
  {
    key: "BorrowBooks",
    pathName: routeName.e_library.books_borrow,
    elements: <BorrowBooks />,
  },
  {
    key: "ShoppingCart",
    pathName: routeName.e_library.books_shop_cart,
    elements: <ShoppingCartBooks />,
  },
  {
    key: "ManageBooks",
    pathName: routeName.e_library.manage_books,
    elements: <ManageBooks />,
  },
  {
    key: "ManageBooksCreate",
    pathName: routeName.e_library.manage_books_create,
    elements: <ManageBooksDetail library_category_name="BOOK" view={false} />,
  },
  {
    key: "ManageBooksDetail",
    pathName: routeName.e_library.manage_books_detail,
    elements: <ManageBooksDetail library_category_name="BOOK" view={false} />,
  },
  {
    key: "ManageBooksView",
    pathName: routeName.e_library.manage_books_view,
    elements: <ManageBooksDetail library_category_name="BOOK" view={true} />,
  },
  {
    key: "ManageEBooks",
    pathName: routeName.e_library.manage_e_books,
    elements: <ManageEbooks />,
  },
  {
    key: "ManageEBooksCreate",
    pathName: routeName.e_library.manage_e_books_create,
    elements: <ManageEbooksDetail view={false} />,
  },
  {
    key: "ManageEBooksDetail",
    pathName: routeName.e_library.manage_e_books_detail,
    elements: <ManageEbooksDetail view={false} />,
  },
  {
    key: "ManageEBooksView",
    pathName: routeName.e_library.manage_e_books_view,
    elements: <ManageEbooksDetail view={true} />,
  },
  {
    key: "ManageTheSes",
    pathName: routeName.e_library.manage_the_ses,
    elements: <ManageTheSes />,
  },
  {
    key: "ManageTheSesCreate",
    pathName: routeName.e_library.manage_the_ses_create,
    elements: <ManageTheSesDetail view={false} />,
  },
  {
    key: "ManageTheSesDetail",
    pathName: routeName.e_library.manage_the_ses_detail,
    elements: <ManageTheSesDetail view={false} />,
  },
  {
    key: "ManageTheSesView",
    pathName: routeName.e_library.manage_the_ses_view,
    elements: <ManageTheSesDetail view={true} />,
  },
  {
    key: "ManageJournal",
    pathName: routeName.e_library.manage_journal,
    elements: <ManageJournal />,
  },
  {
    key: "ManageJournalCreate",
    pathName: routeName.e_library.manage_journal_create,
    elements: <ManageJournalDetail view={false} />,
  },
  {
    key: "ManageJournalDetail",
    pathName: routeName.e_library.manage_journal_detail,
    elements: <ManageJournalDetail view={false} />,
  },
  {
    key: "ManageJournalView",
    pathName: routeName.e_library.manage_journal_view,
    elements: <ManageJournalDetail view={true} />,
  },
  {
    key: "ManageAudio",
    pathName: routeName.e_library.manage_audio_book,
    elements: <ManageAudioBook />,
  },
  {
    key: "ManageAudioCreate",
    pathName: routeName.e_library.manage_audio_book_create,
    elements: <ManageAudioBookDetail view={false} />,
  },
  {
    key: "ManageAudioDetail",
    pathName: routeName.e_library.manage_audio_book_detail,
    elements: <ManageAudioBookDetail view={false} />,
  },
  {
    key: "ManageAudioView",
    pathName: routeName.e_library.manage_audio_book_view,
    elements: <ManageAudioBookDetail view={true} />,
  },
  {
    key: "ManagePodcast",
    pathName: routeName.e_library.manage_podcast,
    elements: <ManagePodcast />,
  },
  {
    key: "ManagePodcastCreate",
    pathName: routeName.e_library.manage_podcast_create,
    elements: <ManagePodcastDetail view={false} />,
  },
  {
    key: "ManagePodcastDetail",
    pathName: routeName.e_library.manage_podcast_detail,
    elements: <ManagePodcastDetail view={false} />,
  },
  {
    key: "ManagePodcastView",
    pathName: routeName.e_library.manage_podcast_view,
    elements: <ManagePodcastDetail view={true} />,
  },
  {
    key: "ManageVideo",
    pathName: routeName.e_library.manage_videos,
    elements: <ManageVideos />,
  },
  {
    key: "ManageVideoCreate",
    pathName: routeName.e_library.manage_videos_create,
    elements: <ManageVideosDetail view={false} />,
  },
  {
    key: "ManageVideoDetail",
    pathName: routeName.e_library.manage_videos_detail,
    elements: <ManageVideosDetail view={false} />,
  },
  {
    key: "ManageVideoView",
    pathName: routeName.e_library.manage_videos_view,
    elements: <ManageVideosDetail view={true} />,
  },
  {
    key: "ElibraryBooks",
    pathName: routeName.e_library.books,
    elements: <Books />,
  },
  {
    key: "ElibraryEBooks",
    pathName: routeName.e_library.e_books,
    elements: <EBooks />,
  },
  {
    key: "Journal",
    pathName: routeName.e_library.journal,
    elements: <Journal />,
  },
  {
    key: "Thesis",
    pathName: routeName.e_library.the_sis,
    elements: <TheSis />,
  },
  {
    key: "Podcast",
    pathName: routeName.e_library.podcast,
    elements: <Podcast />,
  },
  {
    key: "AudioBook",
    pathName: routeName.e_library.audio_book,
    elements: <AudioBooks />,
  },
  {
    key: "ElibraryVideo",
    pathName: routeName.e_library.video,
    elements: <Videos />,
  },
  {
    key: "ElibraryBooksList",
    pathName: routeName.e_library.books_list,
    elements: <BooksList />,
  },
  {
    key: "EbooksList",
    pathName: routeName.e_library.e_books_list,
    elements: <EbooksList />,
  },
  {
    key: "JournalList",
    pathName: routeName.e_library.journal_list,
    elements: <JournalList />,
  },
  {
    key: "TheSisList",
    pathName: routeName.e_library.the_sis_list,
    elements: <TheSisList />,
  },
  {
    key: "AudioBooksList",
    pathName: routeName.e_library.audio_book_list,
    elements: <AudioBooksList />,
  },
  {
    key: "PodcastList",
    pathName: routeName.e_library.podcast_list,
    elements: <PodcastList />,
  },
  {
    key: "VideoELibraryList",
    pathName: routeName.e_library.video_list,
    elements: <VideosList />,
  },
  {
    key: "ElibraryBooksDetail",
    pathName: routeName.e_library.books_detail,
    elements: <BooksDetail />,
  },
  {
    key: "ElibraryEBooksDetail",
    pathName: routeName.e_library.e_books_detail,
    elements: <EbooksDetail />,
  },
  {
    key: "JournalDetail",
    pathName: routeName.e_library.journal_detail,
    elements: <JournalDetail />,
  },
  {
    key: "TheSisDetail",
    pathName: routeName.e_library.the_sis_detail,
    elements: <TheSisDetail />,
  },
  {
    key: "AudioBookDetail",
    pathName: routeName.e_library.audio_book_detail,
    elements: <AudioBookDetail />,
  },
  {
    key: "PodcastDetail",
    pathName: routeName.e_library.podcast_detail,
    elements: <PodcastDetail />,
  },
  {
    key: "VideoDetail",
    pathName: routeName.e_library.video_detail,
    elements: <VideoDetail />,
  },
  {
    key: "ELibrarySearchGlobal",
    pathName: routeName.e_library.search_global,
    elements: <ELibrarySearchGlobal />,
  },
  {
    key: "ManageLibraryType",
    pathName: routeName.e_library.manage_library_type,
    elements: <ManageLibraryType />,
  },
  {
    key: "ManageLibraryAuthor",
    pathName: routeName.e_library.manage_library_author,
    elements: <ManageLibraryAuthor />,
  },
  {
    key: "ManageLibraryBanner",
    pathName: routeName.e_library.manage_library_banner,
    elements: <ManageLibraryBanner />,
  },
  {
    key: "ManagePaymentChannels",
    pathName: routeName.e_library.manage_payment_channels,
    elements: <ManagePaymentChannels />,
  },
  {
    key: "ManageReport",
    pathName: routeName.e_library.manage_report,
    elements: <ManageReport />,
  },
  {
    key: "ManageOrders",
    pathName: routeName.e_library.manage_orders,
    elements: <ManageOrders />,
  },
  {
    key: "ManageOrdersDetail",
    pathName: routeName.e_library.manage_orders_detail,
    elements: <ManageOrdersDetail view={false} />,
  },
  {
    key: "ManageOrdersDetailView",
    pathName: routeName.e_library.manage_orders_view,
    elements: <ManageOrdersDetail view={true} />,
  },
  {
    key: "ManageBorrow",
    pathName: routeName.e_library.manage_borrow,
    elements: <ManageBorrow />,
  },
  {
    key: "ManageBorrowDetail",
    pathName: routeName.e_library.manage_borrow_detail,
    elements: <ManageBorrowDetail />,
  },
  {
    key: "ManageBorrowDetailView",
    pathName: routeName.e_library.manage_borrow_view,
    elements: <ManageBorrowDetail view={true} />,
  },


  {
    key: "ManageRequestForms",
    pathName: routeName.request_form.manage_request_forms,
    elements: <ManageRequestForms />,
  },
  {
    key: "ManageRequestFormDetail",
    pathName: routeName.request_form.manage_request_form_add,
    elements: <ManageRequestFormDetail />,
  },
  {
    key: "ManageRequestFormDetail",
    pathName: routeName.request_form.manage_request_form_detail,
    elements: <ManageRequestFormDetail />,
  },
  {
    key: "ManageRequestFormDetail",
    pathName: routeName.request_form.manage_request_form_view,
    elements: <ManageRequestFormDetail view={true} />,
  },
  {
    key: "VisaRequest",
    pathName: routeName.request_form.visa_request,
    elements: <VisaRequest />,
  },
  {
    key: "VisaRequestCreate",
    pathName: routeName.request_form.visa_request_create,
    elements: <VisaRequestCreate />,
  },
  {
    key: "VisaRequestDetail",
    pathName: routeName.request_form.visa_request_detail,
    elements: <VisaRequestDetail />,
  },
  {
    key: "VisaRequestDetail",
    pathName: routeName.request_form.visa_request_view,
    elements: <VisaRequestDetail view={true} />,
  },
  {
    key: "ManageRequest",
    pathName: routeName.request_form.manage_request,
    elements: <ManageRequest />,
  },
  {
    key: "ManageRequestDetail",
    pathName: routeName.request_form.manage_request_detail,
    elements: <ManageRequestDetail />,
  },
  {
    key: "ManageRequestDetail",
    pathName: routeName.request_form.manage_request_view,
    elements: <ManageRequestDetail view={true} />,
  },
  {
    key: "ManagePaymentChannelsVisa",
    pathName: routeName.request_form.manage_payment_channels_visa,
    elements: <ManagePaymentChannelsVisa />,
  },
  {
    key: "VisaIntendant",
    pathName: routeName.request_form.visa_intendant,
    elements: <VisaIntendant />,
  },
];

export const reportRouteData: routerData[] = [
  {
    key: "PersonnelManagementExportDetailById",
    pathName: routeName.cms.PersonnelManagementDetailExportById,
    elements: <FormPersonnelExport />,
  },
  {
    key: "PrintOnlineLeaveSubmission",
    pathName: routeName.cms.PrintOnlineLeaveSubmission,
    elements: <PrintOnlineLeaveSubmission />,
  },
  {
    key: "PrintReportConsultation",
    pathName: routeName.cms.PrintReportConsultation,
    elements: <ExportReportConsultationRequestDetail />,
  },
  {
    key: "LeaveFormPublic",
    pathName: routeName.public.leave_form,
    elements: <LeaveFormPublic />,
  },


];
